import React, {Component} from 'react';
import {show_popup} from "../functions";

class ProgressBarPopup extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="row">
                <div className="col-12 text-center">
                    <div className="row m-3">
                        <div className="col-12 text-center gray">
                            File upload process in progress...
                        </div>
                    </div>
                    <div className="row m-3">
                        <div className="col-12">
                            <div className="progress">
                                <div className="progress-bar bg-success progress-bar-striped progress-bar-animated"
                                     style={{width: this.props.progress + '%'}}>{this.props.progress}%
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ProgressBarPopup;

export function showProgressBarPopup(percent) {
    show_popup(<ProgressBarPopup progress={percent}/>, {auto_close: false});
}